<template>
  <WizardStep name="dateOfBirth">
    <FieldGroup
      :title="`${formContext.getValue(
        'personal.firstname'
      )}, wann bist Du geboren?`"
    >
      <div class="row">
        <div class="col-md-6">
          <FormulateInput
            type="date"
            name="date"
            label="Format: TT.MM.JJJJ"
            placeholder="Geburtsdatum"
            validation="bail|required|years_ago:18"
          />
        </div>
      </div>
    </FieldGroup>
    <Panel slot="footer" title="Ab welchem Alter kann ich bei Euch arbeiten?">
      Du musst mindestens 18 Jahre alt sein, um bei uns zu arbeiten.
    </Panel>
  </WizardStep>
</template>

<script>
import formContextAware from '../mixin/formContextAware';

export default {
  mixins: [formContextAware],
};
</script>
